import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoutingTabTitleService } from '@shared/service';
import { filter, Subject, Subscription, tap } from 'rxjs';
import { CategoryService } from './category.service';
import { ProductService } from './product.service';

@Injectable({
    providedIn: 'root',
})
export class ProductDescriptionService {
    private categoryService = inject(CategoryService);
    private productService = inject(ProductService);
    private routingTabTitleService = inject(RoutingTabTitleService);
    private activatedRoute = inject(ActivatedRoute);

    categorySlug = this.activatedRoute.snapshot.params['slug'];
    categoryName: string | undefined;
    category$ = this.categoryService.category$;
    productSlug = this.activatedRoute.snapshot.params['productId'];
    product$ = this.productService.product$;
    error$ = this.productService.error$;
    seoTitle$ = new Subject<string>();
    seoDescription$ = new Subject<string>();

    subscriptions$ = new Subscription();

    getProductSeoDescription() {
        this.subscriptions$.add(
            this.category$
                .pipe(
                    filter((value) => value !== null),
                    tap((value) => {
                        this.categoryName = value.name;
                    }),
                )
                .subscribe(),
        );
        this.subscriptions$.add(
            this.product$
                .pipe(
                    filter((data) => data !== null),
                    tap((value) => {
                        if (this.categoryName == undefined && value.parameters.default_ct_count == null) {
                            this.routingTabTitleService.setTitle(`${value.name} | PZ Stelmach`);

                            this.seoDescription$.next(
                                this.routingTabTitleService.translateSeoDescription(`SEO.PRODUCT.DESCRIPTION`, {
                                    pattern: value.patternName,
                                    height: value.parameters.height,
                                    width: value.parameters.width,
                                }),
                            );
                        } else if (this.categoryName == undefined) {
                            this.routingTabTitleService.setTitle(` ${value.name} | PZ Stelmach`);

                            this.seoDescription$.next(
                                this.routingTabTitleService.translateSeoDescription(`SEO.PRODUCT.DESCRIPTION.weight`, {
                                    weight: value.parameters.default_ct_count,
                                    pattern: value.patternName,
                                    height: value.parameters.height,
                                    width: value.parameters.width,
                                }),
                            );
                        } else if (value.parameters.default_ct_count == undefined) {
                            this.routingTabTitleService.setTitle(`${this.categoryName} - ${value.name} | PZ Stelmach`);

                            this.seoDescription$.next(
                                this.routingTabTitleService.translateSeoDescription(`SEO.PRODUCT.DESCRIPTION.category`, {
                                    category: this.categoryName,
                                    pattern: value.patternName,
                                    height: value.parameters.height,
                                    width: value.parameters.width,
                                }),
                            );
                        } else {
                            this.routingTabTitleService.setTitle(`${this.categoryName} - ${value.name} | PZ Stelmach`);

                            this.seoDescription$.next(
                                this.routingTabTitleService.translateSeoDescription(`SEO.PRODUCT.DESCRIPTION.categoryAndWeight`, {
                                    weight: value.parameters.default_ct_count,
                                    category: this.categoryName,
                                    pattern: value.patternName,
                                    height: value.parameters.height,
                                    width: value.parameters.width,
                                }),
                            );
                        }
                    }),
                )
                .subscribe(),
        );
    }
}
